import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg-video-on",
  "use": "svg-video-on-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"svg-video-on\"><path d=\"m20.31 5.717-2.959 2.544v-.82c0-1.459-1.153-2.641-2.576-2.641H4.576C3.153 4.8 2 5.982 2 7.44v9.12c0 1.458 1.153 2.64 2.576 2.64h10.199c.8 0 1.516-.374 1.988-.961a2.669 2.669 0 0 0 .588-1.68v-.82l2.959 2.543c.818.482 1.49.086 1.49-.88v-10.8c0-.97-.67-1.366-1.49-.885Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol